(ns minorodata.components.forms.formatted-text
  (:require [goog.string.format]
            [goog.string :as goog.string]
            [ajax.url]
            [reitit.frontend]
            [clojure.string]))


(defn maybe-get-in
  "Returns scalar values verbatim, but gets values from `fields` map when `arg` is a path"
  [fields arg]
  (if (or (vector? arg)
          (seq? arg))
    (get-in fields arg "[null]")
    arg))


(defn typography-formatted-block [{:keys [component fields format args kleene-globals]
                                   :or   {component "p"}}]
  (let [data          (assoc fields :kleene-globals kleene-globals)
        format-params (map (partial maybe-get-in data) args)]
    [:div {:class "my-2"}
     [component {:class ""}
      (try
       (apply goog.string/format (cons format format-params))
       (catch js/Error e
         (js/console.error e)
         (ex-message e)))]]))
